// @unocss-include
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, } from '@a-type/ui';
import { graphql, useMutation } from '@biscuits/graphql';
import * as CONFIG from '../config.js';
import { useMe } from '../hooks/graphql.js';
import { TOS_UPDATED_AT } from '../tos.js';
const acceptTosMutation = graphql(`
	mutation AcceptTos {
		acceptTermsOfService {
			id
			acceptedTermsOfServiceAt
		}
	}
`);
export function TosPrompt() {
    const { data } = useMe();
    const [acceptTos] = useMutation(acceptTosMutation);
    if (!(data === null || data === void 0 ? void 0 : data.me)) {
        return null;
    }
    const needsToUpdateTos = !data.me.acceptedTermsOfServiceAt ||
        new Date(data.me.acceptedTermsOfServiceAt) < TOS_UPDATED_AT;
    return (_jsx(Dialog, { open: needsToUpdateTos, children: _jsxs(DialogContent, { children: [_jsx(DialogTitle, { children: "Terms of Service Update" }), _jsx("p", { children: "We've updated our terms of service. Please review and accept to continue using Biscuits apps." }), _jsxs("div", { className: "flex flex-col items-start gap-2", children: [_jsx(Button, { asChild: true, emphasis: "ghost", children: _jsx("a", { href: `${CONFIG.HOME_ORIGIN}/tos`, target: "_blank", children: "Terms of Service" }) }), _jsx(Button, { asChild: true, emphasis: "ghost", children: _jsx("a", { href: `${CONFIG.HOME_ORIGIN}/privacy`, target: "_blank", children: "Privacy Policy" }) })] }), _jsxs(DialogActions, { children: [_jsx(Button, { asChild: true, children: _jsx("a", { href: `${CONFIG.HOME_ORIGIN}/settings`, target: "_blank", children: "Manage Plan or Log Out" }) }), _jsx(Button, { emphasis: "primary", onClick: () => acceptTos(), children: "Accept" })] })] }) }));
}
//# sourceMappingURL=TosPrompt.js.map